export enum Device {
  BRACELET = 'bracelet',
  CUFF = 'cuff',
}
